import React, { Component } from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import { SettingsSelect, ChangeShippingWrapper } from './styled';
import Row from '../UI/Row';
import Button from '../UI/Button';
import CloseImage from '../UI/CloseImage';
import Text from '../UI/Text';
import { hideChangeShippingCountry } from '../../modules/manageChangeShippingCountrySelector';
import { Mobile } from '../MediaQuery';
import LoadingDots from '../LoadingDots/LoadingDots';
import Store from '../../common/models/Store';
import { Country } from '../../common/models';
import { CountryProps } from '../../common/models/CountryInterface';

const mapStateToProps = ({
  api: { s3BasePath, countries, countryId },
  countryCode,
  isLoadingChangeShipping,
}: Store) => {
  return { countries, countryCode, countryId, isLoadingChangeShipping, s3BasePath };
};

const mapDispatchToProps = dispatch => ({
  hideChangeShipping: () => dispatch(hideChangeShippingCountry()),
});

interface ChangeShippingProps {
  countries: CountryProps[];
  countryCode: string;
  countryId: number;
  hideChangeShipping: () => void;
  isLoadingChangeShipping: boolean;
  s3BasePath: string;
}

interface ChangeShippingState {
  selected?: any;
  showWarning?: boolean;
}

class ChangeShipping extends Component<ChangeShippingProps, ChangeShippingState> {
  constructor(props: ChangeShippingProps) {
    super(props);
    this.state = {
      selected: props.countries.find(country => country.id === props.countryId),
      showWarning: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.saveShippingCountry = this.saveShippingCountry.bind(this);
  }

  handleChange(e) {
    const { countries, countryId } = this.props;
    const selected = countries.find(country => country.id === e.target.value);
    const showWarning = selected.id !== countryId;
    this.setState({ selected, showWarning });
  }

  saveShippingCountry() {
    const { countryCode } = this.props;
    const { selected } = this.state;
    const currUrl = window.location.href;
    const find = `/${countryCode}`;
    const re = new RegExp(find);
    window.location.href = currUrl.replace(re, `/${selected.isoCode.toLowerCase()}`);
  }

  render() {
    const { countries, countryId, hideChangeShipping, s3BasePath, isLoadingChangeShipping } = this.props;
    const { selected, showWarning } = this.state;
    return (
      <ChangeShippingWrapper>
        <Mobile>
          <Row justifyContent="flex-end" margin="20px 30px">
            <CloseImage
              data-cy="close-change-shipping-country"
              onClick={hideChangeShipping}
              src={`${s3BasePath}mkt/icon/x_black.png`}
            />
          </Row>
          <Row justifyContent="center" margin="0 0 10px">
            <Text fontFamily="Avenir Black" fontSize="12px">
              CHANGE SHIPPING COUNTRY
            </Text>
          </Row>
        </Mobile>
        <Row justifyContent="flex-start" margin="10px 15px 0px">
          <span>I'm shipping to: </span>
        </Row>
        <Row justifyContent="center" margin="5px 15px">
          <SettingsSelect data-cy="select-change-shipping-country" onChange={this.handleChange}>
            {map(countries, country => (
              /* eslint-disable-next-line eqeqeq */
              <option key={country.id} selected={country.id == countryId} value={country.id}>
                {country.country}
              </option>
            ))}
          </SettingsSelect>
        </Row>

        <Row data-cy="currency-text-change-shipping-country" justifyContent="flex-start" margin="5px 15px">
          <Text fontSize="12px">
            Your order will be billed in{' '}
            {selected.id === Country.unitedStates() || selected.id === Country.canada() ? 'USD' : 'EUR'}.
          </Text>
        </Row>

        <Row data-cy="warning-text-change-shipping-country" justifyContent="flex-start" margin="0px 15px 5px">
          {showWarning && (
            <Text color="red" fontSize="12px">
              Please note: the items in your shopping bag may be lost if you choose to proceed.
            </Text>
          )}
        </Row>

        <Row justifyContent="center">
          <Button
            backgroundColor="#000000"
            border="none"
            borderRadius="0px"
            color="#FFFFFF"
            data-cy="confirm-change-shipping-country"
            disabled={isLoadingChangeShipping}
            fontSize="13px"
            height="40px"
            margin="0 15px 10px"
            marginButton="0"
            onClick={this.saveShippingCountry}
            type="submit"
          >
            {isLoadingChangeShipping ? <LoadingDots color="white" /> : 'CONFIRM'}
          </Button>
        </Row>
      </ChangeShippingWrapper>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeShipping);
